import type { Prototype } from "../prototype-types";

export const jasmineShenPrototypes: Prototype[] = [
  {
    id: "ai-enhanced-pos-integration",
    name: "AI-enhanced POS integration",
    path: "",
    externalUrl: "https://curved-fence-53885437.figma.site",
    description:
      "Adding AI-suggestions/description improvements to the POS bulk editor",
    owner: "Jasmine",
    createdAt: "2026-03-31",
    lastUpdated: "2026-03-31",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "legacy",
    isExternal: true,
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/73f38a6da3acea77359716d806a90d8b2bcd74ee2f9c9b9b45941c5b2621b2e2.png",
    creationTool: "figma-make",
  },
  {
    id: "js-copy-hover-explorations",
    name: "Copy hover explorations",
    path: "/js/copy-hover-explorations",
    description:
      "Order details copy affordances — hover band, copy icon, tooltip, and optional post-copy coachmark.",
    owner: "Jasmine Shen",
    createdAt: "2026-05-19",
    lastUpdated: "2026-05-28",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/d41d261e2d279d4b346f1ed119b540a5b914184fe9a4e53ca9bd91d20c5cf4b0.png",
    creationTool: ["claude-code", "cursor"],
  },
  {
    id: "js-gif-ai-bulk-editor-tags-and-categories",
    name: "GIF: AI bulk editor tags and categories",
    path: "/js/gif-ai-bulk-editor-tags-and-categories",
    description:
      "Exploring a GIF used for a POS marketing email — AI bulk editor tags and categories.",
    owner: "Jasmine Shen",
    createdAt: "2026-06-03",
    lastUpdated: "2026-06-03",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/cdd5c5c78955289540825ca63e543ca9da9ebc176f691f15cd68dcd2fd28ba00.png",
    creationTool: "claude-code",
  },
  {
    id: "js-gif-ai-bulk-product-descriptions",
    name: "GIF: AI bulk product descriptions",
    path: "/js/gif-ai-bulk-product-descriptions",
    description:
      "Exploring a GIF used for a POS marketing email — AI bulk product descriptions.",
    owner: "Jasmine Shen",
    createdAt: "2026-06-04",
    lastUpdated: "2026-06-04",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    thumbnail: "https://cdn.prerelease.faire.dev/fastly/d825e40a6ab431a3f9a0ed72302e287a8d4439ed8dd68e6145b385841c3f9e1c.png",
    creationTool: "claude-code",
  },
  {
    id: "js-streamline-dtfs-payments",
    name: "Streamline DTFs payments",
    path: "/js/streamline-dtfs-payments",
    description:
      "Explore how our new DTFs policy will appear on all retailer surfaces.",
    owner: "Jasmine Shen",
    createdAt: "2026-07-08",
    lastUpdated: "2026-07-08",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail: "https://cdn.prerelease.faire.dev/fastly/745d9b2996c8bee30acf09916054d0c488cf903d83dd2189a943d1a7d0b10e5c.png",
    creationTool: "claude-code",
  },
];
